module.exports = __webpack_public_path__ + "img/p2AR_btn_back.155fb422.png";